module.exports = __webpack_public_path__ + "2a5f4f887404e5197a8dad6ab98e0963.png";